import T from 'prop-types';

const rootNode = document.getElementById('app-insights-general-root');

const AppInsightsAllowed = ({ children }) => (
  rootNode ? children({ pageName: rootNode.dataset.pageName }) : null
);

AppInsightsAllowed.propTypes = {
  children: T.func.isRequired,
};

export default AppInsightsAllowed;
